import React from 'react';
import SidebarCard from './SidebarCard';
import ListField from './ListField';

const RELATED_FORMAT = /^[^~\s]+~[^~\s]+$/;

const relatedLink = (value) => {
  const [domain, slug] = String(value).split('~');
  return domain && slug ? `/domain/${domain}/pages/${encodeURIComponent(slug)}/edit` : null;
};

/* Tags, related pages, key points and shareable quotes -- four ListFields. */
export default function TaxonomyCard({ page, open, onToggle, onChange, onNavigate }) {
  return (
    <SidebarCard id="taxonomy" title="Taxonomy & related" open={open} onToggle={onToggle}>
      <ListField
        id="page-tags"
        label="Tags"
        items={page.tags}
        onChange={(next) => onChange('tags', next)}
        placeholder="e.g. recipes"
        chips
        emptyText="No tags yet."
        addLabel="Add tag"
      />

      <ListField
        id="page-related"
        label="Related pages"
        items={page.related_pages}
        onChange={(next) => onChange('related_pages', next)}
        placeholder="domain_id~page-slug"
        validate={(v) => (RELATED_FORMAT.test(v) ? null : 'Use the form domain_id~page-slug')}
        hint="Format: domain_id~page-slug, e.g. cupcaketree_com~cake-recipes"
        emptyText="No related pages yet."
        itemLink={relatedLink}
        onNavigate={onNavigate}
        renderItem={(v) => {
          const [domain, slug] = String(v).split('~');
          return (
            <span>
              <span style={{ color: 'var(--color-muted)' }}>{domain}</span> / {slug}
            </span>
          );
        }}
        addLabel="Add related"
      />

      <ListField
        id="page-key-points"
        label="Key points"
        items={page['key-points']}
        onChange={(next) => onChange('key-points', next)}
        placeholder="The most important takeaway…"
        emptyText="No key points yet."
        addLabel="Add point"
      />

      <ListField
        id="page-quotes"
        label="Shareable quotes"
        items={page.shareable_quotes}
        onChange={(next) => onChange('shareable_quotes', next)}
        placeholder="A memorable line from this page…"
        multiline
        emptyText="No quotes yet."
        renderItem={(q) => <span style={{ fontStyle: 'italic' }}>“{q}”</span>}
        addLabel="Add quote"
      />
    </SidebarCard>
  );
}
